module.exports = __webpack_public_path__ + "img/login.1108c447.png";